export const CLEAR_AUTHOR_VALUE = "__all_author__";

export type SearchAuthorOption = {
  id: string;
  label: string;
  avatarUrl: string;
};

type SearchAuthorCandidate = {
  id: number | string;
  display_name?: string | null;
  guid?: string | null;
  image_url?: string | null;
};

export const createSearchAuthorOption = (
  author: SearchAuthorCandidate,
): SearchAuthorOption => {
  const id = String(author.id);
  return {
    id,
    label: author.display_name || String(author.id),
    avatarUrl: author.image_url || "",
  };
};

export const buildSearchAuthorOptions = (
  authors: SearchAuthorCandidate[],
  currentUser?: SearchAuthorCandidate | null,
): SearchAuthorOption[] => {
  const uniqueAuthors = new Map<string, SearchAuthorOption>();

  for (const user of authors) {
    uniqueAuthors.set(String(user.id), createSearchAuthorOption(user));
  }

  if (currentUser?.id) {
    uniqueAuthors.set(
      String(currentUser.id),
      createSearchAuthorOption(currentUser),
    );
  }

  return Array.from(uniqueAuthors.values()).sort((a, b) =>
    a.label.localeCompare(b.label),
  );
};

export const buildSearchAuthorLabelMap = (
  authorOptions: SearchAuthorOption[],
): Map<string, string> =>
  new Map(
    authorOptions.map((authorOption) => [authorOption.id, authorOption.label]),
  );
